/** @module csi/widget/_svg/_ShapeAlign */
define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"csi/_base/underscore",
	"./_Plugin",
	"./util",
	"dojo/text!./resources/Button.html",
], function(declare,Button,_,_Plugin,util,template) {

	return declare([Button, _Plugin], {
		templateString: template,
		/**
		 * Shape align option: Each plugin should set corresponding value.
		 * Possible options are top,left,right,bottom,hcenter,vcenter.
		 * @property {String}
		 */
		shapeAlignOption: "left",

		/**
		 * Plugin is enabled only if there are more than 1 shape selected.
		 * @param {Array.<Shape>} shapes - selected shapes
		 * @param {Object} shapeAttrs - Shape attributes
		 * @param {Object} textAttrs - Text attributes
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && shapes && shapes.length > 0;
		},

		/**
		 * Align shape as per alignement option selected.
		 *
		 * @param {Event} e - Click event
		 */
		onClick: function(e) {
			this.editor.canvasApp.pageApi().alignObjects(this.shapeAlignOption);
		}
	});
});
